import { Icon } from '@lightspeed/design-system-react'
import React from 'react'

import { reactular } from '@vendhq/reactular'
import { UnknownLineItem as UnknownLineItemModel } from '../../../models/line-item'

interface Props {
  item: UnknownLineItemModel
  onDelete: (item: UnknownLineItemModel) => void
}

export const UnknownLineItem: React.FC<Props> = ({ item, onDelete }) => {
  return (
    <div className="unknown-line-item vd-pt4 vd-pr4 vd-pl9 vd-flex vd-flex--align-start">
      <Icon className="wr-input-error-icon" icon="exclamation-triangle" />
      <div className="vd-ml4 vd-pb4">
        <div className="vd-text-label">{item.name}</div>
        <div className="vd-text-supplementary vd-colour-no">
          This product doesn’t exist.
          <button
            type="button"
            className="vd-ml1 vd-btn vd-btn--link"
            onClick={() => onDelete(item)}
          >
            Remove?
          </button>
        </div>
      </div>
      <button
        type="button"
        className="vd-btn vd-btn--icon-no unknown-line-item-remove"
        onClick={() => onDelete(item)}
        aria-label="Delete product"
      >
        <Icon icon="trash" />
      </button>
    </div>
  )
}

export const UnknownLineItemComponent = reactular<Props>(UnknownLineItem, [
  'item',
  'onDelete',
])
